const TrashRestoreOutline = ({ color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      width="17"
      height="17"
      {...props}
    >
      <path
        fill={color}
        d="m8.709,14.294l-1.414-1.414,3.299-3.299c.776-.775,2.037-.772,2.812,0l3.3,3.3-1.414,1.414-2.291-2.291v5.997h-2v-6.008l-2.291,2.302Zm14.291-8.294h-1.682l-1.703,15.331c-.17,1.522-1.452,2.669-2.982,2.669H7.328c-1.531,0-2.812-1.147-2.981-2.669l-1.704-15.331h-1.643v-2h6v-2c0-1.103.897-2,2-2h6c1.103,0,2,.897,2,2v2h6v2Zm-14-2h6v-2h-6v2Zm10.305,2H4.656l1.679,15.11c.056.507.483.89.993.89h9.305c.51,0,.938-.383.994-.891l1.678-15.109Z"
      />
    </svg>
  );
};

export default TrashRestoreOutline;
